 export const SHOW_ALERT = "SHOW_ALERT"
 export const SET_AUTH = "SET_AUTH"
 export const ADD_IMAGE = "ADD_IMAGE"